import { render, staticRenderFns } from "./DeliveryLegalDialog.vue?vue&type=template&id=ad645e86&"
import script from "./DeliveryLegalDialog.vue?vue&type=script&lang=js&"
export * from "./DeliveryLegalDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryLegalDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports